"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { GridSvg } from "@/components/gridSvg";
import Link from "next/link";

export default function OurProcess() {
  return (
    <section className="wrapper py-10 relative">
      <GridSvg />
      <div className={"flex flex-col gap-5 items-center text-center"}>
        <Badge>Our Process</Badge>
        <h1 className={"text-4xl font-bold"}>
          How We <span className={"text-primary"}>Work Together</span>
        </h1>
        <p className={"text-muted-foreground text-lg font-semibold lg:w-[65%]"}>
          Our streamlined process ensures you get the right technology solutions
          efficiently and effectively.
        </p>
        <div className={"relative grid grid-cols-1 md:grid-cols-4 gap-5 mt-5"}>
          <span
            className={
              "w-[5px] lg:w-full absolute  lg:top-1/2 left-1/2 lg:left-0 h-full lg:h-[5px] bg-primary"
            }
          ></span>
          {siteConfig.process.map((process, index) => (
            <div
              key={index}
              className={
                " relative square-gradient-bg !border-primary !border-2 !border-dashed\n" +
                "square-gradient-bg !border-primary !border-2 !border-dashed py-10 px-5 rounded"
              }
            >
              <div
                className={
                  "absolute w-full h-full bg-background/95 opacity-100 top-0 left-0 z-10"
                }
              ></div>
              <div
                className={
                  "w-5 h-5 bg-primary absolute top-0 left-[48.3%] rounded-full animate-pulse duration-[10000ms]" +
                  " -translate-y-3 z-30"
                }
                style={{
                  animationDelay: `${index * 0.1}s`,
                }}
              ></div>
              <div className={"flex flex-col items-center gap-4 sticky z-20"}>
                <span className={"text-white bg-primary p-5" + " rounded"}>
                  <process.icon />
                </span>
                <h1 className={"text-3xl font-bold text-primary"}>
                  {process.step}
                </h1>
                <h3 className={"text-xl font-bold"}>{process.title}</h3>
                <p className={"text-muted-foreground "}>
                  {process.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className={"mt-14 flex flex-col gap-5 items-center"}>
          <h1 className={"text-4xl font-bold "}>
            Ready to Transform Your
            <span className={"text-primary"}> Business?</span>
          </h1>
          <p
            className={"text-muted-foreground text-lg lg:w-[65%] font-semibold"}
          >
            Discover how our comprehensive technology solutions can drive
            innovation and growth in your industry. Let&apos;s build the future
            together.
          </p>
          <span className={"flex gap-5"}>
            <Link href={"/faq#contact"}>
              <Button>
                <p>Get Started Today</p> <ChevronRight />
              </Button>
            </Link>
            <Link href={"/faq#contact"}>
              <Button variant={"secondary"}>Schedule Consultation</Button>
            </Link>
          </span>
        </div>
      </div>
    </section>
  );
}
